import React from "react";
import { MarketCampaignContext } from "../../market-campaign/MarketCampaign.context-state";
import { IUpsellInsight } from "../types/upsell.types";
import { ILead } from "../../../redux/leads/leads.types";
import { Step3MarketCampaignChannel } from "../../market-campaign/campaign-steps";
import { mockCampaignContext } from "../../../helpers/mockCampaignContext";
import {
  IWhatsAppTemplate,
  IWhatsAppTemplateData,
} from "../../../redux/whatsappTemplate/whatsappTemplate.types";
import { IUpsellInsightData } from "../../../redux/upsellLead";

interface IRecommendedTemplateProps {
  open: boolean;
  data: IWhatsAppTemplate[] | null;
  upsellData: IUpsellInsight[] | IUpsellInsightData[] | null;
  leadData: ILead | null;
  onClose: () => void;
}

export const RecommendedTemplate = (props: IRecommendedTemplateProps) => {
  const { open, data, upsellData, leadData } = props;

  const [createdRecommendTemplateData, setCreatedRecommendTemplateData] =
    React.useState<IWhatsAppTemplateData | null>(null);

  if (!open) return null;

  return (
    <MarketCampaignContext.Provider value={mockCampaignContext}>
      <Step3MarketCampaignChannel
        leadRecommendedTemplates={data}
        isFromUpsellLead={true}
        upsellData={upsellData as IUpsellInsight[] | null}
        leadData={leadData}
        createdRecommendTemplateData={createdRecommendTemplateData}
        setCreatedRecommendTemplateData={(template) => {
          setCreatedRecommendTemplateData(template);
        }}
      />
    </MarketCampaignContext.Provider>
  );
};
